<template>
  <v-container>
    <h1>Gestion de l'inscription des bénévoles</h1>
    <v-form ref="updateForm">
      <h2>Texte de présentation</h2>
      <wysiwyg v-model="text" />
      <h2>Url document inscriptions</h2>
      <v-text-field v-model="url" :label="$t('Lien')" />
      <v-btn color="primary" @click="files.push({ title: '', text: '' })"
      >Ajouter fichier
      </v-btn
      >
      <v-btn color="primary" @click="save">
        <v-icon>mdi-briefcase-download</v-icon>
        Sauver
      </v-btn>
    </v-form>
    <Loading :visible="isLoading" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import Loading from "../../components/Loading";

const servicePrefix = "GlobalParams";

export default {
  name: "InscriptionBenevoles",
  servicePrefix,
  components: {
    Loading
  },
  data() {
    return {
      item: null,
      url: null,
      text: null
    };
  },
  beforeMount() {
    this.isLoading = true;
    const routeName = this.$route?.name;
    if (!routeName) {
      console.error("Route name introuvable");
      this.isLoading = false;
      return;
    }
    const decodedName = decodeURIComponent(routeName);
    this.retrieve(decodedName)
      .then(() => {
        const item = this.find(decodedName);

        if (!item || !item.value) {
          console.error("Item introuvable ou incomplet");
          this.item = null;
          this.url = "";
          this.text = "";
          return;
        }

        this.item = item;
        this.url = item.value.url || "";
        this.text = item.value.text || "";
      })
      .catch((e) => {
        console.error(e);
        this.item = null;
        this.url = "";
        this.text = "";
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  computed: {
    ...mapFields("globalParam", {
      isLoading: "isLoading"
    }),
    ...mapGetters({
      find: "globalParam/find"
    })
  },
  methods: {
    ...mapActions("globalParam", {
      retrieve: "load",
      update: "update"
    }),
    save() {
      this.update(
        Object.assign(this.item, {
          value: {
            text: this.text,
            url: this.url
          }
        })
      );
    }
  },
  watch: {}
};
</script>
